import type { AnalysisRemarksViewTranslation } from '@/assets/locales/views/analysisRemarks/analysisRemarks.translation.en.ts';

import { AnalysisRemarkStateDto } from '@/api/generated';

export const analysisRemarksViewTranslation: AnalysisRemarksViewTranslation = {
  body: {
    comments: 'Komentarze',
    open: 'Otwórz',
    stateOptions: {
      [AnalysisRemarkStateDto.Done]: 'Ukończony',
      [AnalysisRemarkStateDto.InProgress]: 'W trakcie',
      [AnalysisRemarkStateDto.New]: 'Nowy',
      [AnalysisRemarkStateDto.Seen]: 'Widziany',
      [AnalysisRemarkStateDto.ToVerify]: 'Do weryfikacji',
    },
  },
  buttons: {
    importExternalRecruitments: 'Importuj procesy z eRecruitera',
    showActive: 'Pokaż aktywne',
  },
  columns: {
    actions: 'Akcje',
    candidate: 'Kandydat',
    content: 'Uwaga',
    createdAt: 'Data',
    createdBy: 'Autor',
    process: 'Proces',
    state: 'Status',
  },
  commentsDialog: {
    buttons: {
      cancel: 'Anuluj',
      submit: 'Dodaj komentarz',
      submitAndVerify: 'Dodaj i oznacz do weryfikacji',
    },
    field: 'Komentarz',
    instruction: 'Przejrzyj dyskusję i dodaj nowy komentarz do tej uwagi.',
    noResults: 'Brak komentarzy.',
    placeholder: 'Wpisz komentarz',
    submitAndVerifyDisabledHint: 'Dostępne, gdy uwaga ma status „Widziany” lub „W trakcie”.',
    title: 'Komentarze',
  },
  filters: {
    searchPhrase: 'Szukaj uwag...',
    statuses: 'Statusy',
  },
};
